import React from 'react'
import { Form, Picker } from 'antd-mobile';
import { labelValue } from 'utils/constant';

const { NODATA } = labelValue

/**
 * 【'是'，'否'】选择框
 * @param {
 *  item:对应的表单模板
 *  setFormInfo:向传给接口的对象中新增对应表单数据
 * } props
 * @returns
 */
export function BpmFormChoose(props) {
  const { postName, label, required, message, pickerTitle, placeholder, option } = props.item
  const { setFormInfo, form } = props

  /** 显示在表单内字段 */
  function onValue(value) {
    if (value.length && value[0].label !== NODATA) {
      return value[0].label
    } else {
      return placeholder
    }
  }

  const rules = () => {
    let nationValue = 1
    let addressValue = 2
    /** 户籍地字段名称 */
    let nationName = ''
    /** 常住地字段名称 */
    let addressName = ''
    switch (postName) {
      case 'affirmation':  // 就困
        nationName = 'permanent'
        addressName = 'address'
      break
      case 'FREGISTYPE':   // 失业登记类型
        addressName = 'permanent'
        nationName = 'nation'
        break
      case 'FjobPlaceType':   // 我要就业常住地类型
        addressName = 'address118'
        nationName = 'permanent118'
        break
      case 'FRegisType':   // 就业登记常住地类型
        addressName = 'address'
        nationName = 'permanent'
        break
      default:
    }
    if (nationName && addressName) {
      return [
        {
          required: required,
          validator: (rule, value) => {
            if (!value) {
              return Promise.reject(`请选择${label}`);
            }
            const name = value[0] === nationValue ? nationName : addressName
            if (value) {
              if (form.getFieldValue(name)?.[0] && form.getFieldValue(name)?.[0] !== 20) {
                  return Promise.reject('选择的登记地需要在福建省内');
              }
              // else {
              //   return Promise.reject('如选择常住地作为认定地，请选择福建省');
              // }
            }
            return Promise.resolve();
          }
        },
      ]
    } else {
      return [{ required: required, message: message }]
    }
  }

  // const validateTrigger = () => {
  //   if (postName === 'affirmation') {
  //     return ['onChange', 'onConfirm', 'onBlur']
  //   } else {
  //     return ['onChange', 'onConfirm']
  //   }
  // }

  return (
    <Form.Item
      name={postName}
      label={label}
      rules={rules()}
      trigger='onConfirm'
      onClick={(e, PickerRef) => {
        PickerRef.current?.open()
      }}
      //validateTrigger={validateTrigger()}
      shouldUpdate={(prevValues, curValues) => {
        return postName === 'affirmation' && prevValues.address !== curValues.address
      }}
    >
      <Picker
        title={pickerTitle}
        columns={option}
        onConfirm={value => setFormInfo(postName, value[0])}
      >
        {value => onValue(value)}
      </Picker>
    </Form.Item>
  )
}